// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"308":"a23d05ea","823":"a374768c"}[chunkId] + ".css";
};